import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CrazyRadioComponent} from './crazy-radio.component';

import {MatButtonModule, MatRadioModule} from '@angular/material';
import {CrazyComponent} from './crazy.component';
import {RouterModule} from '@angular/router';

import { routes } from './crazy.routing';

@NgModule({
    imports     : [
        CommonModule,
        RouterModule.forChild(routes),
        MatButtonModule,
        MatRadioModule,
    ],
    exports     : [
        CrazyRadioComponent,
        CrazyComponent,
    ],
    declarations: [CrazyRadioComponent, CrazyComponent],
})
export class CrazyModule {
}
